// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3APwd","input":"Form_input__3LcnC","divider":"Form_divider__PnvpZ","actions":"Form_actions__18F8X","footer":"Form_footer__2Lnz7","forgot":"Form_forgot__3b-4L"};